import { render, staticRenderFns } from "./AppointmentNotNeeded.vue?vue&type=template&id=2351e48d&"
import script from "./AppointmentNotNeeded.vue?vue&type=script&lang=js&"
export * from "./AppointmentNotNeeded.vue?vue&type=script&lang=js&"
import style0 from "./AppointmentNotNeeded.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports